var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React from 'react';
import t from 'prop-types';
import Boton from './boton';
import * as HERRAMIENTA from './constantes';

function BotonMuestraGrosor(props) {
  var valor = props.valor;
  var clases = ['botonGrosor'];
  var style = {
    backgroundSize: props.valor
  };
  return React.createElement(Boton, _extends({}, props, {
    style: style,
    extraClases: clases
  }), valor > 20 && React.createElement('span', {
    className: 'centradoAbsoluto'
  }, valor));
}

BotonMuestraGrosor.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identificador del boton, por defecto: 'LapizGrosor' */
  herramientaId: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton, por defecto: 'Pizarra' */
  grupo: t.string,

  /** grosor */
  valor: t.number,

  /** (id, grupo, valor) => {...} */
  onPresionado: t.func.isRequired
} : {};
BotonMuestraGrosor.defaultProps = {
  herramientaId: HERRAMIENTA.LAPIZ_GROSOR_ID,
  grupo: HERRAMIENTA.GRUPO_PIZARRA
};
export default BotonMuestraGrosor;